export const USER_ROLES = {
  ALL: 'ALL',
  ADMINISTRATOR: 'ADMINISTRATOR',
  ACADEMY_MANAGER: 'ACADEMY_MANAGER',
  ACADEMY_TRAINEE: 'ACADEMY_TRAINEE',
  TRAINING_MANAGER: 'TRAINING_MANAGER',
  TRAINEE: 'TRAINEE',
  HR_MANAGER: 'HR_MANAGER',
  HR_STAFF: 'HR_STAFF',
  PERFORMANCE_MANAGER: 'PERFORMANCE_MANAGER',
  PERFORMANCE_STAFF: 'PERFORMANCE_STAFF',
  SUPER: 'SUPER',
}
